/* @flow-strict */

import React, { PureComponent } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'visible',
    padding: 0,
    textAlign: 'center',
    maxHeight: '98vh'
  },
  overlay: {
    overflowY: 'auto'
  }
};

type CropZoneJCropType = {
  src?: string,
  openedCropModal: boolean,
  useDefaultCrop: boolean,
  onDone: () => void,
  aspect?: number
}

class CropZoneJCrop extends PureComponent<CropZoneJCropType> {
  props: CropZoneJCropType;

  constructor(props) {
    super(props);

    this.state = {
      src: props.src || null,
      crop: {
        unit: 'px',
        width: 100,
        aspect: props.aspect || 2560 / 964 // 16 / 9,
      }
    };
  }

  componentDidUpdate(prevProps: CropZoneJCropType) {
    if (this.props.src !== prevProps.src) {
      this.setState({
        src: this.props.src
      });
    }
  }

  initDefaultCropBox = () => {
    this.setState({
      crop: {
      x: 0,
      y: this.imageRef.height / 4,
      width: this.imageRef.width,
      height: this.imageRef.height / 2,
      unit: 'px',
      aspect: this.props.aspect || 2560 / 964
      }
    });
  }

  initCropBoxWithProps = () => {
    const { x1, x2, y1, y2 } = this.props.crop;
    const scaleX = this.imageRef.naturalWidth / this.imageRef.width;
    const scaleY = this.imageRef.naturalHeight / this.imageRef.height;

    const cropBox = {
      x: x1 / scaleX,
      y: y1 / scaleY,
      height: y2 / scaleY - y1 / scaleY,
      width: x2 / scaleX - x1 / scaleX,
      aspect: this.props.aspect || 2560 / 964,
      unit: 'px'
    };

    this.setState({
      crop: {
        ...this.state.crop,
        ...cropBox
      }
    });
  }

  onImageLoaded = image => {
    this.imageRef = image;
    const { useDefaultCrop } = this.props;

    if (useDefaultCrop) {
      this.initDefaultCropBox();
    } else {
      this.initCropBoxWithProps();
    }
    return false;   // If you setState the crop in here you should return false.
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleDone = async () => {
    const { crop } = this.state;
    const image = this.imageRef;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const convertedCropBox = {
      x1: crop.x * scaleX,
      x2: crop.x * scaleX + crop.width * scaleX,
      y1: crop.y * scaleY,
      y2: crop.y * scaleY + crop.height * scaleY
    };

    this.props.onDone(convertedCropBox);
  };

  render() {
    const { crop, src } = this.state;

    return (
      <Modal isOpen={this.props.openedCropModal} ariaHideApp={false} style={customStyles} onClose={this.handleClose}>
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={this.handleClose}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
            <h4>Crop Your Image</h4>
          </div>
          <div className="modal-body">
            <div className="cropZone" onDoubleClick={this.handleDone}>
        <div />
        {src && (
          <ReactCrop
            src={src}
            crop={crop}
            ruleOfThirds
            keepSelection={crop.height} // if cropBox setted (has it`s own height) then prevent collapse it on outside click
            crossorigin='anonymous'
            imageAlt='Event background'
            onImageLoaded={this.onImageLoaded}
            onChange={this.onCropChange}
          />
        )}
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-pink autofocus" onClick={this.handleDone}>
              Done
            </button>
            <div style={{ clear: 'both' }} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default CropZoneJCrop;
